import React, { useEffect, useState, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { HrFlexContainer, HrTitleContainer, HrTitleH4, HrGridContainer } from '@components/styles/hr-styles';
import { useTranslation } from 'react-i18next';
import { SelectForm } from '@components/form/select';
import { Input } from '@components/form/input';
import styled from 'styled-components';
import { vacancyRequirementType } from '../../../constant/vacancy-requirement';
import { useQuery } from '../../../hook/use-query';
import { DisplaySettingsContext } from '../../store/display-settings';

const Grid = styled(HrGridContainer)`
  padding: 0 32px;

  @media (max-width: 768px) {
    padding: 0 16px;
    grid-template-columns: 1fr;
  }
`;

export const Referral = observer(
  ({ control, formState, vacancyRequirement, register, unregister, setValue, postulant, action }) => {
    const [t] = useTranslation();
    const _query = useQuery();
    const [disabled, setdisabled] = useState(true);
    const source = _query.get('source');
    const { known } = postulant;
    useEffect(() => {
      if (known) {
        setValue('known.relationCompany', known.relationCompany ? 'yes' : 'no');
        setValue('known.name', known.name);
        setValue('known.relation', known.relation);
      }
    }, [known]);

    if (action === 'edit') {
      return null;
    }

    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

    return (
      <>
        {(vacancyRequirement.known !== 0 || source === 'referral') && (
          <HrFlexContainer flexDirection='row' justifyContent='space-between' gap='24px'>
            <HrTitleContainer borderBottom={darkMode ? '1px solid #767676' : ''} >
              <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} >{t('postulant.referral.title')}</HrTitleH4>
            </HrTitleContainer>
            <Grid>
              <SelectForm
                title={t('postulant.referral.known.relationCompany')}
                id='known.relationCompany'
                data={[
                  { value: 'yes', label: 'Sí' },
                  { value: 'no', label: 'No' }
                ]}
                control={control}
                formState={formState}
                isSearchable
                errorPosition='bottom'
                validate={{ required: vacancyRequirement.known === vacancyRequirementType.mandatory }}
                onChangee={(data) => {
                  setdisabled(data.value !== 'yes');
                  if (data.value === 'no') {
                    unregister('known.name');
                    unregister('known.relation');
                    setValue('known.name', '');
                    setValue('known.relation', '');
                  }
                }}
              />
              <Input
                title={t('postulant.referral.known.name')}
                placeholder={t('postulant.referral.known.placeholder.name')}
                name='known.name'
                type='text'
                register={register}
                formState={formState}
                validate={{
                  required:
                    (vacancyRequirement.known === vacancyRequirementType.mandatory && disabled === false) ||
                    disabled === false
                }}
                errorPosition='bottom'
                disabled={disabled}
              />
              <SelectForm
                title={t('postulant.referral.known.relation')}
                id='known.relation'
                data={[
                  { value: 'Conocido', label: 'Conocido' },
                  { value: 'Amigo', label: 'Amigo' },
                  { value: 'Familiar', label: 'Familiar' }
                ]}
                control={control}
                formState={formState}
                isSearchable
                validate={{
                  required:
                    (vacancyRequirement.known === vacancyRequirementType.mandatory && disabled === false) ||
                    disabled === false
                }}
                disabled={disabled}
                errorPosition='bottom'
              />
            </Grid>
          </HrFlexContainer>
        )}
      </>
    );
  }
);
